import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BInputGroup, BFormInput, VBTooltip, BListGroup, BBadge, BListGroupItem, BFormGroup, BFormFile, BForm, BFormTextarea, BRow, BCol, BButton, BSpinner, BCard, BIcon, BFormCheckbox, BFormRadioGroup, BFormSelect, BFormSelectOption, BCollapse, BModal, BAlert,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import vSelect from 'vue-select'
import ProjectNoteEditor from '@/components/ProjectNoteEditor.vue'
import AttachmentMediaCard from '@/components/AttachmentMediaCard.vue'
import GisWorkLocations from '../GisWorkLocations.vue'
import TeamEditorCard from './TeamEditorCard.vue'

export default {
  inject: {
    attachmentsRoot: { default: null },
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BSpinner,
    BCard,
    BButton,
    BIcon,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BFormFile,
    BFormTextarea,
    BInputGroup,
    BListGroup,
    BListGroupItem,
    BCol,
    FeatherIcon,
    BBadge,
    BFormRadioGroup,
    BFormSelect,
    BFormSelectOption,
    BCollapse,
    BModal,
    BAlert,
    vSelect,
    ProjectNoteEditor,
    AttachmentMediaCard,
    GisWorkLocations,
    TeamEditorCard,
  },
  computed: {
    a() {
      return this.attachmentsRoot
    },
  },
  filters: {
    formatJalali(value) {
      if (!value) return ''
      const date = new Date(value)
      return date.toLocaleDateString('ar-EG')
    },
  },
}
